<!--
 * @Author: your name
 * @Date: 2020-07-23 18:58:16
 * @LastEditTime: 2024-07-03 17:35:24
 * @LastEditors: 白志明
 * @Description: In User Settings Edit
 * @FilePath: \digitalnewspaperofinternet\src\views\newspaperContent\newspaperContent.vue
-->
<template>
  <div class="newspaper_content">
    <newspaperOfPc v-if="loaded && isShowPc"></newspaperOfPc>
    <newspaperOfMobile v-if="loaded && !isShowPc"></newspaperOfMobile>
  </div>
</template>
<script>
import "trs-app-js-bridge";
import newspaperOfPc from './newspaperOfPc/newspaperOfPc.vue'; //数字报pc端
import newspaperOfMobile from './newspaperOfMobileAndPad/newspaper.vue'; //数字报移动端
export default {
  name: "newspaperContent",
  components: {
    newspaperOfPc,
    newspaperOfMobile
  },
  data() {
    return {
      loaded: false,
      isShowPc: true, //展示pc端数字报或者手机端
      clientWidth: '' //设备的宽度
    }
  },
  mounted() {
    this.resizeFun();
    this.windowResize();
    this.loadCPsdk(() => {
    })
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeFun, true);
  },
  methods: {
    /**
     * [windowResize description]浏览器宽度变化
     * @return {[type]} [description]
     */
    windowResize() {
      window.addEventListener('resize', this.resizeFun, true);
    },
    /**
     * [resizeFun description]根据设备宽度选择加载不同的组件
     * @return {[type]} [description]
     */
    resizeFun() {
      this.clientWidth = window.outerWidth;
      if (this.clientWidth > 1000) {
        this.isShowPc = true;
      } else {
        this.isShowPc = false;
      }
      this.loaded = true;
    }
  }
}
</script>
<style scoped lang="less">
.newspaper_content {
  width: 100%;
  height: 100%;
}
</style>